import store from "../redux/store";
import config from "../config";

export default function getAccessFor(function_code) {
  const state = store.getState();
  const functionID = config.functions[function_code];

  return !!Number(state.auth.accesses[functionID]);
}
